module.exports = __webpack_public_path__ + "static/media/home_logo_sm.e233176a.png";